import { defineStore } from 'pinia'
import { reactive } from 'vue'
import {
    deleteKeycloakCredential,
    getKeycloakCredentialsForNaturalProfile,
    KeycloakCredentialMetadata,
    KeycloakCredentialResponse,
} from '../api'
import { TwoFactorAuthenticationTypes } from '../../typings'
import { usePersonalAccountDataState } from './useAccountDataPersonal'

export interface KeycloakCredential {
    createAction?: string
    updateAction?: string
    removeable: boolean
    category: string
    userCredentialMetadatas: Array<KeycloakCredentialMetadata>
    type: string
}

export const useKeycloakState = defineStore('keycloak', {
    state: () => {
        return {
            credentials: reactive([]),
            availableTwoFactorAuthenticationTypes: reactive([]),
            credentialsLoading: false,
        }
    },
    actions: {
        async fetchCredentials() {
            this.credentialsLoading = true

            const personalAccountState = usePersonalAccountDataState()
            const person = personalAccountState.naturalProfile

            getKeycloakCredentialsForNaturalProfile(person.natural_profile_uid)
                .then((response) => {
                    const credentialData = response.data
                        .filter((item: KeycloakCredentialResponse) => item.category === 'two-factor')
                        .filter((item: KeycloakCredentialResponse) =>
                            Object.values(TwoFactorAuthenticationTypes).includes(
                                item.type as TwoFactorAuthenticationTypes
                            )
                        )

                    const availableTwoFactorAuthenticationTypes = credentialData.map(
                        (item: KeycloakCredentialResponse) => {
                            return {
                                name: item.type,
                                createAction: item.createAction,
                            }
                        }
                    )

                    const credentials = credentialData.flatMap((item) => {
                        return item.userCredentialMetadatas.map((metadata: KeycloakCredentialMetadata) => {
                            return {
                                type: item.type,
                                removeable: item.removeable,
                                ...metadata.credential,
                            }
                        })
                    })

                    this.$patch({
                        credentials: credentials,
                        availableTwoFactorAuthenticationTypes: availableTwoFactorAuthenticationTypes,
                    })
                })
                .finally(() => {
                    this.credentialsLoading = false
                })
        },
        async deleteCredential(credentialId: string) {
            const personalAccountState = usePersonalAccountDataState()
            const person = personalAccountState.naturalProfile

            return deleteKeycloakCredential(person.natural_profile_uid, credentialId)
        },
    },
})

export function getKeycloakUserActionUrl() {
    return window.condaKeycloakUserActionUrl
}
